import React from "react";
import NavBarStyles from "../styles/Navbar.module.scss";

function GradientBar() {
  return <div className={NavBarStyles.gradientBar}></div>;
}

export default GradientBar;
